export default __webpack_public_path__ + "static/media/ge6.346dff09.jpg";